import {
  flattenErrors,
} from '@equifinance/shared';
import { useCreditContext } from '../../contexts/credit';
import PageErrors from '../Errors/PageErrors';
import CreditTables from './CreditTables';
import InsolvencyTables from './InsolvencyTables';
import DisbursementDetails from './DisbursementDetails/DisbursementDetails';
import CreditToggleButtons from '../Tasks/components/TaskToggleButtons';

export default function CreditForm() {
  const { credit, handleToggleAll } = useCreditContext();
  const { errors, warnings } = credit;

  const flattenedErrors = flattenErrors(errors);
  const flattenedWarnings = flattenErrors(warnings);

  return (
    <>
      <PageErrors id={credit?.id} errors={flattenedErrors} warnings={flattenedWarnings} />
      <CreditToggleButtons
        onExpandAll={() => handleToggleAll(true)}
        onCollapseAll={() => handleToggleAll(false)}
      />

      <CreditTables
        type="secured"
      />
      <CreditTables
        type="unsecured"
      />
      <InsolvencyTables />
      <DisbursementDetails />
    </>
  );
}
